import { Link } from "react-router-dom";
import { useCart } from "../../context/CartContext";
import "./ProductCard.css";

export default function ProductCard({ product, index }) {
  const { isProductInCart, getCartItemForProduct } = useCart();

  // Check if product is in cart (by productId only, since we don't have variant info here)
  const isInCart = isProductInCart(product.id);
  const cartItem = getCartItemForProduct(product.id);

  const truncateText = (text, maxLength = 100) => {
    if (!text || text.length <= maxLength) return text;
    return (
      <>
        {text.substring(0, maxLength)}...
        <Link to={`/product/${product.id}`} className="read-more-link">
          Read More
        </Link>
      </>
    );
  };

  return (
    <div 
      className="product-card"
      style={{ 
        animationDelay: `${index * 0.1}s`,
        '--card-index': index
      }}
    >
      {/* Product Image */}
      <Link to={`/product/${product.id}`} className="product-image-link">
        <div className="card-image-container">
          {product.image && (
            <img 
              src={product.image} 
              alt={product.name || 'Premium Energy'} 
              className="card-image"
              onLoad={(e) => {
                // console.log(`Image loaded successfully: ${product.image}`);
                e.target.style.display = 'block';
                if (e.target.nextSibling) {
                  e.target.nextSibling.style.display = 'none';
                }
              }}
              onError={(e) => {
                console.error(`Image failed to load: ${product.image}`);
                e.target.style.display = 'none';
                if (e.target.nextSibling) {
                  e.target.nextSibling.style.display = 'flex';
                }
              }}
            />
          )}
          <div className="empty-image-placeholder" style={{ display: product.image ? 'none' : 'flex' }}>
            <span>📦</span>
            <small>{product.name || 'Product Image'}</small>
          </div>
        </div>
      </Link>

      {/* Product Info */}
      <div className="product-info">
        <Link to={`/product/${product.id}`} className="product-name">
          {product.name || 'Premium Energy'}
        </Link>
        
        {/* One-line benefit text */}
        <div className="product-benefit">
          {truncateText(product.benefit || "Clean energy • No crash")}
        </div>
        
        {/* Price */}
        <div className="price-block">
          <div className="current-price">
            {product.price > 0 ? `$${product.price.toFixed(2)}` : "Price Unavailable"}
          </div>
          {product.originalPrice && product.originalPrice > 0 && (
            <div className="original-price">M.R.P: ${product.originalPrice.toFixed(2)}</div>
          )}
        </div>

        {/* View Product Button */}
        <Link 
          to={`/product/${product.id}`} 
          className="view-product-btn"
        >
          {isInCart ? (
            <>
              ✓ In Cart ({cartItem?.quantity || 1}) - View Details
            </>
          ) : (
            <>
              View Product
            </>
          )}
        </Link>
      </div>
    </div>
  );
}


